var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPakett01ASvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "140px",
    height: "80px",
    viewBox: "0 0 140 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Pakett_01a_SVG") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pakett_01a",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fillOpacity: 0.084458,
    fill: "#000000",
    x: 4,
    y: 8,
    width: 1,
    height: 64,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    fillOpacity: 0.084458,
    fill: "#000000",
    x: 131,
    y: 8,
    width: 1,
    height: 64,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-2",
    fillOpacity: 0.084458,
    fill: "#000000",
    x: 113,
    y: 8,
    width: 1,
    height: 64,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-3",
    fillOpacity: 0.084458,
    fill: "#000000",
    x: 95,
    y: 8,
    width: 1,
    height: 64,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-4",
    fillOpacity: 0.084458,
    fill: "#000000",
    x: 77,
    y: 8,
    width: 1,
    height: 64,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-5",
    fillOpacity: 0.084458,
    fill: "#000000",
    x: 58,
    y: 8,
    width: 1,
    height: 64,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-6",
    fillOpacity: 0.084458,
    fill: "#000000",
    x: 40,
    y: 8,
    width: 1,
    height: 64,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-7",
    fillOpacity: 0.084458,
    fill: "#000000",
    x: 22,
    y: 8,
    width: 1,
    height: 64,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(4.000000, 36.000000)",
    stroke: "#E7A300",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 4,
    x2: 128,
    y2: 4,
    id: "Path-14"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 128,
    cy: 4,
    r: 4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPakett01ASvg);
export default __webpack_public_path__ + "static/media/Pakett_01a_SVG.e885d923415ea2dad4454b9c998ac9c2.svg";
export { ForwardRef as ReactComponent };